import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetCampaignQuery } from '@/services/endpoints/campaigns';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { ConnectedDestinationsSection, DatasourcesUsedSection, RulesUsedSection } from './common';

export const CampaignDetailsContent: FC = () => {
  const { id: campaignId } = useParams<{ id: string }>();
  const workspace = useWorkspace();

  const { data: campaign } = useGetCampaignQuery({
    campaignId,
    workspaceId: workspace.id,
  });

  return (
    <div className='grid gap-y-8 px-8 pt-8'>
      <ConnectedDestinationsSection campaign={campaign} />
      <DatasourcesUsedSection audienceId={campaign.audienceId} />
      <RulesUsedSection audienceId={campaign.audienceId} />
    </div>
  );
};
